import { compact } from 'lodash';

const getObjWithType = (type, obj) => (obj ? { type, ...obj } : null);

function getMappedStatistic(overall, saleStatistics) {
    const statistic = compact([overall].concat(saleStatistics))
        .reduce((result, { colts, fillies, ...total }) => {
            result.push(
                 getObjWithType('total', total),
                 getObjWithType('colts', colts),
                 getObjWithType('fillies', fillies)
            );
            return result;
        }, []);
    return compact(statistic);
}

export default getMappedStatistic;



// WEBPACK FOOTER //
// ./src/js/horse/salesStatistics/helpers/getMappedStatistic.js